/* Revesur.es — global.js
   Lichte vanilla JS: scroll-reveal, header/mega menu, taalwisselaar,
   hoeveelheid + staffelkorting-hint, add-to-cart feedback. Geen dependencies. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal (Intersection Observer) ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (!els.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  initReveal();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });

  /* ---------- Header: schaduw bij scroll ----------
     Met hysterese: de compacte header maakt de pagina iets korter, waardoor
     één vaste drempel een aan/uit-loop (trillen) kan veroorzaken. De kloof
     tussen de aan- en uit-drempel is groter dan het hoogteverschil van de
     header, dus de toestand kan nooit meer heen en weer flippen. */
  var header = document.querySelector('.site-header');
  if (header) {
    var HEADER_ADD_AT = 32, HEADER_REMOVE_AT = 4;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > HEADER_ADD_AT) {
          header.classList.add('is-scrolled');
        } else if (y < HEADER_REMOVE_AT) {
          header.classList.remove('is-scrolled');
        }
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Mega menu (desktop, hover-intent + toetsenbord) ---------- */
  document.querySelectorAll('.nav-item--mega').forEach(function (item) {
    var trigger = item.querySelector('.nav-link');
    var panel = item.querySelector('.mega-panel');
    if (!trigger || !panel) return;
    var closeTimer;
    function open() {
      clearTimeout(closeTimer);
      document.querySelectorAll('.nav-item--mega.is-open').forEach(function (other) {
        if (other !== item) other.classList.remove('is-open');
      });
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }, 120);
    }
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(min-width: 990px)').matches) {
        e.preventDefault();
        item.classList.contains('is-open') ? item.classList.remove('is-open') : open();
      }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { item.classList.remove('is-open'); trigger.focus(); }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-item--mega')) {
      document.querySelectorAll('.nav-item--mega.is-open').forEach(function (i) { i.classList.remove('is-open'); });
    }
  });

  /* ---------- Mobiel menu drawer ---------- */
  var drawer = document.querySelector('.mobile-drawer');
  var drawerToggle = document.querySelector('[data-drawer-toggle]');
  if (drawer && drawerToggle) {
    function setDrawer(openState) {
      drawer.classList.toggle('is-open', openState);
      drawerToggle.classList.toggle('is-active', openState);
      drawerToggle.setAttribute('aria-expanded', String(openState));
      document.documentElement.classList.toggle('drawer-open', openState);
    }
    drawerToggle.addEventListener('click', function () {
      setDrawer(!drawer.classList.contains('is-open'));
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-drawer-close]')) setDrawer(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setDrawer(false);
    });
    drawer.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.mobile-nav__item').classList.toggle('is-open');
      });
    });
  }

  /* ---------- Taalwisselaar / custom dropdowns ---------- */
  document.querySelectorAll('[data-dropdown]').forEach(function (dd) {
    var btn = dd.querySelector('[data-dropdown-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !dd.classList.contains('is-open');
      document.querySelectorAll('[data-dropdown].is-open').forEach(function (o) { o.classList.remove('is-open'); });
      dd.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
    });
    dd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { dd.classList.remove('is-open'); btn.focus(); }
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('[data-dropdown].is-open').forEach(function (o) { o.classList.remove('is-open'); });
  });

  /* ---------- Hoeveelheid-kiezer + staffelkorting-hint ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.dir === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  function checkTierHint(qty, m2) {
    document.querySelectorAll('[data-tier-hint]').forEach(function (hint) {
      var thresholdQty = parseInt(hint.dataset.thresholdQty, 10) || 10;
      var thresholdM2 = parseInt(hint.dataset.thresholdM2, 10) || 50;
      var thresholdPrice = parseFloat(hint.dataset.thresholdPrice) || 0;
      var totalPrice = 0;
      if (qty && window.__revesurVariant && window.__revesurVariant.price_cents) {
        totalPrice = (window.__revesurVariant.price_cents * qty) / 100;
      }
      var show = (qty && qty >= thresholdQty) ||
        (m2 && m2 >= thresholdM2) ||
        (thresholdPrice > 0 && totalPrice >= thresholdPrice);
      hint.classList.toggle('is-visible', !!show);
      hint.setAttribute('aria-hidden', String(!show));
      if (show) {
        var link = hint.querySelector('a[data-tier-link]');
        if (link) {
          var url = new URL(link.href, window.location.origin);
          if (qty) url.searchParams.set('cantidad', qty);
          if (m2) url.searchParams.set('m2', m2);
          link.href = url.pathname + url.search + (url.hash || '#presupuesto');
        }
      }
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty] input, [name="quantity"]')) {
      checkTierHint(parseInt(e.target.value, 10) || 0, window.__revesurM2 || 0);
    }
  });
  window.RevesurTierHint = checkTierHint;
  /* Bij variantwissel opnieuw toetsen: andere rolmaat = andere totaalprijs */
  document.addEventListener('revesur:variant', function () {
    var qtyInput = document.querySelector('[data-product-main] [name="quantity"]');
    checkTierHint(qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0, window.__revesurM2 || 0);
  });

  /* ---------- Add-to-cart feedback (AJAX) ---------- */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.dataset.state = 'loading'; }
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            /* De teller staat op display:none zolang 'is-empty' erop staat. Zonder dit
               werd het nieuwe aantal wel gezet maar bleef het onzichtbaar tot een refresh. */
            el.classList.toggle('is-empty', cart.item_count === 0);
            el.classList.remove('bump');
            void el.offsetWidth; /* reflow om animatie te herstarten */
            el.classList.add('bump');
          });
          if (btn) {
            btn.dataset.state = 'added';
            btn.innerHTML = btn.dataset.addedLabel || original;
            setTimeout(function () {
              btn.disabled = false; btn.dataset.state = ''; btn.innerHTML = original;
            }, 2200);
          }
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.dataset.state = ''; btn.innerHTML = original; }
          if (err && err.json) {
            err.json().then(function (data) {
              window.alert(data.description || data.message || 'Error');
            });
          } else {
            form.submit(); /* nette fallback: normale POST naar /cart/add */
          }
        });
    });
  });

  /* ---------- Contactformulier-succes scopen ----------
     Shopify's posted_successfully geldt voor álle contactformulieren op de
     pagina tegelijk. Na verzending zet Shopify het form-id in de URL-hash;
     alleen dát formulier toont zijn succesmelding (en verbergt zijn velden),
     de rest blijft gewoon invulbaar. */
  var postedFormId = window.location.hash ? window.location.hash.slice(1) : '';
  document.querySelectorAll('[data-form-success]').forEach(function (successEl) {
    var form = successEl.closest('form');
    if (form && form.id === postedFormId) {
      successEl.hidden = false;
      var fields = form.querySelector('[data-form-fields]');
      if (fields) fields.hidden = true;
    } else {
      successEl.remove();
    }
  });

  /* ---------- Multi-step formulieren (offerte-funnel) ---------- */
  document.querySelectorAll('[data-steps]').forEach(function (root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var dots = root.querySelectorAll('[data-step-dot]');
    var current = 0;
    function goTo(i) {
      current = Math.max(0, Math.min(steps.length - 1, i));
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
        d.classList.toggle('is-done', idx < current);
      });
      var focusable = steps[current].querySelector('input, select, textarea, button');
      if (focusable) focusable.focus({ preventScroll: true });
    }
    root.addEventListener('click', function (e) {
      var next = e.target.closest('[data-step-next]');
      var prev = e.target.closest('[data-step-prev]');
      if (next) {
        e.preventDefault();
        var invalid = steps[current].querySelector(':invalid');
        if (invalid) { invalid.reportValidity(); return; }
        goTo(current + 1);
      }
      if (prev) { e.preventDefault(); goTo(current - 1); }
    });
    /* Voorinvullen vanuit querystring (staffelhint → offerte) */
    var params = new URLSearchParams(window.location.search);
    if (params.has('m2')) {
      var m2Field = root.querySelector('[name="contact[m2]"]');
      if (m2Field) m2Field.value = params.get('m2');
    }
    if (params.has('cantidad')) {
      var qField = root.querySelector('[name="contact[cantidad]"]');
      if (qField) qField.value = params.get('cantidad');
    }
    goTo(0);
  });

  /* ---------- Video-embeds: pas laden na klik op de poster ---------- */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-video-play]');
    if (!play) return;
    var wrap = play.closest('[data-video-embed]');
    if (!wrap || !wrap.dataset.src) return;
    var iframe = document.createElement('iframe');
    iframe.src = wrap.dataset.src;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = play.getAttribute('aria-label') || 'Video';
    wrap.appendChild(iframe);
    play.remove();
  });

  /* ---------- Kit/bundle: alles in één keer in de winkelwagen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;
    var box = btn.closest('[data-bundle]');
    var items = [{ id: parseInt(btn.dataset.mainVariant, 10), quantity: 1 }];
    box.querySelectorAll('[data-bundle-item]').forEach(function (item) {
      items.push({ id: parseInt(item.dataset.variantId, 10), quantity: 1 });
    });
    var original = btn.innerHTML;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.remove('is-empty');
          el.classList.remove('bump');
          void el.offsetWidth;
          el.classList.add('bump');
        });
        btn.innerHTML = btn.dataset.addedLabel;
        setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 2200);
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = original;
      });
  });
  /* Kit volgt de gekozen variant van het hoofdproduct */
  document.addEventListener('revesur:variant', function (e) {
    document.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
      btn.dataset.mainVariant = e.detail.id;
    });
  });

  /* ---------- Imprescindibles: complement los toevoegen aan de winkelwagen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-companion-add]');
    if (!btn || btn.disabled) return;
    var original = btn.innerHTML;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.remove('is-empty');
          el.classList.remove('bump');
          void el.offsetWidth;
          el.classList.add('bump');
        });
        btn.classList.add('is-added');
        btn.innerHTML = btn.dataset.addedLabel;
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.innerHTML = original;
        }, 2200);
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = original;
      });
  });

  /* ---------- Carousels (proyectos, vídeo-reseñas, …) ---------- */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-carousel-root]:not(.is-carousel-init)').forEach(function (root) {
      root.classList.add('is-carousel-init');
      var scroller = root.querySelector('[data-carousel]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var bar = root.querySelector('[data-carousel-progress]');
      var footer = root.querySelector('.carousel__footer');
      if (!scroller) return;

      function step() {
        var items = scroller.querySelectorAll('[data-carousel-item]');
        if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
        return items.length ? items[0].getBoundingClientRect().width : 320;
      }

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        /* niets te scrollen → slider en pijltjes hebben geen functie */
        if (footer) footer.hidden = max <= 4;
        if (prev) prev.disabled = scroller.scrollLeft <= 4;
        if (next) next.disabled = scroller.scrollLeft >= max - 4;
        if (bar && max > 0) {
          var visible = Math.max(scroller.clientWidth / scroller.scrollWidth, 0.08);
          var pos = scroller.scrollLeft / max;
          bar.style.width = visible * 100 + '%';
          bar.style.transform = 'translateX(' + pos * (100 / visible - 100) + '%)';
        }
      }

      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      scroller.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); scroller.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); scroller.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });

      /* Muis-drag op desktop (touch swipet native) */
      var dragging = false, moved = false, startX = 0, startScroll = 0;
      scroller.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        dragging = true; moved = false;
        startX = e.clientX; startScroll = scroller.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 6 && !moved) { moved = true; scroller.classList.add('is-dragging'); }
        if (moved) scroller.scrollLeft = startScroll - delta;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        if (moved) {
          /* uitlijnen op de dichtstbijzijnde kaart */
          var s = step();
          var target = Math.round(scroller.scrollLeft / s) * s;
          scroller.classList.remove('is-dragging');
          scroller.scrollTo({ left: target, behavior: 'smooth' });
        }
      });
      scroller.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      window.addEventListener('resize', update);
      update();
    });
  }
  initCarousels();
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });

  /* ---------- Inhoudsopgave voor blogartikelen ---------- */
  var tocTarget = document.querySelector('[data-toc]');
  var articleBody = document.querySelector('[data-article-body]');
  if (tocTarget && articleBody) {
    var headings = articleBody.querySelectorAll('h2');
    if (headings.length >= parseInt(tocTarget.dataset.tocMin || '3', 10)) {
      var list = document.createElement('ol');
      headings.forEach(function (h, i) {
        if (!h.id) h.id = 'seccion-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
      tocTarget.appendChild(list);
      tocTarget.hidden = false;
    }
  }

  /* ---------- Productbeschrijving inklappen ----------
     De knop verschijnt alleen als de tekst niet past. Bij een korte beschrijving
     halen we de inkorting helemaal weg, zodat er geen zinloos knopje blijft staan. */
  document.querySelectorAll('[data-desc]').forEach(function (wrap) {
    var body = wrap.querySelector('[data-desc-body]');
    var toggle = wrap.querySelector('[data-desc-toggle]');
    var label = wrap.querySelector('[data-desc-label]');
    if (!body || !toggle) return;

    var meerTekst = label ? label.textContent : '';
    var minderTekst = toggle.dataset.lessLabel || meerTekst;

    function meten() {
      if (wrap.classList.contains('is-open')) return;
      var max = parseInt(getComputedStyle(wrap).getPropertyValue('--desc-max'), 10) || 260;
      var past = body.scrollHeight <= max + 8; /* kleine marge tegen afrondingsverschillen */
      wrap.classList.toggle('is-clamped', !past);
      toggle.hidden = past;
    }

    toggle.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? minderTekst : meerTekst;
      if (!open) wrap.scrollIntoView({ block: 'nearest' });
    });

    meten();
    window.addEventListener('resize', meten);
    /* Webfonts veranderen de teksthoogte nadat we gemeten hebben */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(meten);
  });
})();
